import React, { useContext, useMemo } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WMICPolicyLossHistoryPayout } from 'wmic-pe-capability-policy-common-react';

import metadata from './WMICPAPolicyLossHistoryDetailView.metadata.json5';
import messages from './WMICPAPolicyLossHistoryDetailView.messages';

const VEHICLES_PATH = 'lobs.personalAuto.vehicleDTOs.value';

function WMICPAPolicyLossHistoryDetailView(props){
    const {
        value: currentPriorLoss,
        policyVM,
        getDriver
    } = props;
    const translator = useContext(TranslatorContext);

    const driver = useMemo(() => getDriver(currentPriorLoss), [currentPriorLoss, getDriver]);

    const getVehicleDisplayName = useMemo(() => {
        const { paPriorLoss } = currentPriorLoss;
        const vehiclePublicIdValue = paPriorLoss.vehiclePublicID?.value;
        if (vehiclePublicIdValue && vehiclePublicIdValue !== 'other') {
            const vehicle = _.find(_.get(policyVM, VEHICLES_PATH), {publicID: vehiclePublicIdValue});

            return vehicle.displayName;
        }

        return translator(messages.vehicleOther);
    }, [currentPriorLoss, policyVM, translator]);

    const overrideProps = {
        '@field': {
            parentNode: currentPriorLoss,
            readOnly: true
        },
        vehicleOperatorName: {
            value: driver
        },
        vehicleDisplayName: {
            value: getVehicleDisplayName
        },
        payoutComponent: {
            currentPriorLoss
        }
    }

    const resolvers = {
        resolveComponentMap: {
            WMICPolicyLossHistoryPayout
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={currentPriorLoss}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
        />
    )
}

WMICPAPolicyLossHistoryDetailView.propTypes = {
    value: PropTypes.shape({}),
    policyVM: PropTypes.shape({}),
    getDriver: PropTypes.func
};

export default WMICPAPolicyLossHistoryDetailView;